import { render, staticRenderFns } from "./categorySelector.template.vue?vue&type=template&id=3dcfabbf&scoped=true&"
var script = {}
import style0 from "./categorySelector.template.vue?vue&type=style&index=0&id=3dcfabbf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcfabbf",
  null
  
)

export default component.exports